import axios         from '@/axios.js';
import state         from './state';
import stateArticles from '../articles/state';

export default {
  /* Article */
  async fetchArticle({ commit, dispatch }, slug)  {
    if (state.articleLoading) {
      return;
    }

    /* Check if we already loaded that article on feed */
    for (const article of stateArticles.articles) {
      if (article.slug === slug) {
        commit('ARTICLE', article);

        /* Load comments for this specific article */
        return dispatch('fetchComments');
      }
    }

    /* Article not loaded, load it */
    state.articleLoading = true;
    window.scroll(0, 0);

    const request = await axios.get(`/articles?slug=${ slug }`);

    if (request.status !== 200) {
      return commit('ARTICLE', {});
    }

    commit('ARTICLE', request.data.article);

    /* Load comments for this specific article */
    dispatch('fetchComments');
  },

  /* Comments */
  async fetchComments({ commit })  {
    if (state.articleLoading) {
      return;
    }

    if (state.commentsLoading) {
      return;
    }

    if (state.comments.length > 0 && state.comments[0].article_id === state.article.id) {
      return;
    }

    state.commentsLoading = true;
    const request = await axios.get(`/articles/${ state.article.id }/comments`);

    commit('COMMENTS'        , request.data.comments);
    commit('COMMENTS_WAITING', request.data.comment_waiting === 1);
  },

  async storeComment({ commit, dispatch }, { content, parent_id }) {
    if (state.commentsWaiting) {
      return;
    }

    if (content.trim() === '') {
      return;
    }

    const body = { content };

    if (parent_id !== undefined) {
      body.parent_id = parent_id;
    }

    let request;

    try {
      request = await axios.post(`/articles/${ state.article.id }/comments`, body);
    } catch (error) {
      request = error.response;
    }

    dispatch('notification/notification', request, { root: true });

    if (request.status === 200) {
      commit('COMMENTS_WAITING', true);
      commit('COMMENTS_STORE'  , request.data.comment);
    }
  }
}
